
<kendo-gridlayout [cols]="['33%','33%','33%']" [gap]="'20px'">
  <kendo-gridlayout-item [col]="2">
    <kendo-card style=" width: 100%;">
      <!-- <kendo-card-header>
      Connections
    </kendo-card-header> -->
    <kendo-card-body class="d-flex">

      <div class="task-connection-line align-self-center">

        <div class="d-flex task-connection-category flex-direction-column">
          <div class="pr-3 align-self-center">
            <div class="settings-category-badge">
              <!-- <h4>2/4</h4> -->
              <h4><fa-icon icon="plug"></fa-icon></h4>
              <svg xmlns="http://www.w3.org/2000/svg" width="75" height="74.999" viewBox="0 0 75 74.999">
                <g id="Group_294" data-name="Group 294" transform="translate(-249.439 -418.498)">
                  <circle id="Ellipse_15" data-name="Ellipse 15" cx="31.042" cy="31.042" r="31.042" transform="translate(255.897 424.955)" fill="#37c6d0"/>
                  <g id="Group_292" data-name="Group 292" transform="translate(249.439 418.498)">
                    <path id="Path_376" data-name="Path 376" d="M286.939,493.5h-.074v-3.763h.074a34.038,34.038,0,0,0,5.342-.421l.591,3.717A37.87,37.87,0,0,1,286.939,493.5Zm-3.091-.126a37.718,37.718,0,0,1-5.952-.972l.9-3.653a33.862,33.862,0,0,0,5.355.875Zm11.984-.936-.889-3.655a33.531,33.531,0,0,0,5.153-1.708l1.469,3.465A37.361,37.361,0,0,1,295.831,492.435ZM275,491.554a37.412,37.412,0,0,1-5.545-2.377l1.757-3.328a33.5,33.5,0,0,0,4.986,2.137Zm29.3-2.306-1.743-3.334a33.906,33.906,0,0,0,4.592-2.9l2.255,3.011A37.66,37.66,0,0,1,304.294,489.248Zm-37.453-1.586a37.63,37.63,0,0,1-4.812-3.634l2.5-2.811a33.928,33.928,0,0,0,4.331,3.271Zm44.9-3.536-2.49-2.821a33.961,33.961,0,0,0,3.77-3.906l2.908,2.388A37.792,37.792,0,0,1,311.74,484.125Zm-51.884-2.191a37.761,37.761,0,0,1-3.811-4.675l3.1-2.136a33.928,33.928,0,0,0,3.429,4.208Zm57.891-4.554-3.089-2.148a33.837,33.837,0,0,0,2.728-4.688l3.394,1.624A37.566,37.566,0,0,1,317.748,477.381Zm-63.315-2.675a37.537,37.537,0,0,1-2.583-5.454l3.52-1.33a33.653,33.653,0,0,0,2.324,4.9Zm67.541-5.308-3.514-1.345a33.678,33.678,0,0,0,1.522-5.207l3.685.761A37.4,37.4,0,0,1,321.973,469.4ZM250.9,466.387a37.431,37.431,0,0,1-1.194-5.913l3.737-.445a33.64,33.64,0,0,0,1.073,5.317Zm73.258-5.759-3.735-.461a34.218,34.218,0,0,0,.254-4.171c0-.419-.007-.837-.023-1.253l3.76-.139q.026.693.025,1.392A38.044,38.044,0,0,1,324.156,460.628Zm-74.689-3.164q-.027-.731-.028-1.467a38,38,0,0,1,.274-4.554l3.735.452a34.189,34.189,0,0,0-.247,4.1c0,.443.009.885.025,1.325Zm70.979-5.43a33.682,33.682,0,0,0-1.063-5.319L323,445.682a37.485,37.485,0,0,1,1.182,5.916Zm-66.563-2.819-3.687-.752a37.334,37.334,0,0,1,1.681-5.795l3.517,1.338A33.565,33.565,0,0,0,253.883,449.215Zm64.65-5.078a33.631,33.631,0,0,0-2.312-4.909l3.263-1.874a37.433,37.433,0,0,1,2.572,5.461Zm-62.073-2.625-3.4-1.618a37.585,37.585,0,0,1,3.022-5.217l3.093,2.142A33.771,33.771,0,0,0,256.46,441.513Zm58.314-4.584a34.061,34.061,0,0,0-3.421-4.215l2.722-2.6a37.726,37.726,0,0,1,3.8,4.683Zm-53.961-2.279-2.913-2.383a37.87,37.87,0,0,1,4.18-4.347l2.5,2.817A33.964,33.964,0,0,0,260.813,434.649Zm48.588-3.825a34.052,34.052,0,0,0-4.325-3.279l2.026-3.17a37.664,37.664,0,0,1,4.805,3.643Zm-42.722-1.806-2.262-3.007a37.531,37.531,0,0,1,5.1-3.228l1.751,3.33A33.8,33.8,0,0,0,266.68,429.018Zm36.052-2.841a33.636,33.636,0,0,0-4.982-2.148l1.206-3.565a37.551,37.551,0,0,1,5.54,2.389Zm-29.012-1.229-1.476-3.461a37.248,37.248,0,0,1,5.728-1.91l.9,3.654A33.468,33.468,0,0,0,273.719,424.948Zm21.427-1.683a33.641,33.641,0,0,0-5.353-.886l.315-3.75a37.629,37.629,0,0,1,5.951.986Zm-13.618-.573-.6-3.715a37.867,37.867,0,0,1,6.01-.479h.161l-.025,3.762h-.136A34.1,34.1,0,0,0,281.528,422.692Z" transform="translate(-249.439 -418.498)" fill="#37c6d0"/>
                  </g>
                </g>
              </svg>
            </div>
          </div>
          <div class="pr-3 text-light align-self-center">
            Connect
            <!-- <a class="connect-link" href disabled>Add and view accounts</a> -->
            <!-- popup -->

            <!-- {{ this.accounts | json }} -->
          </div>
        </div>
      </div>

      <div class="order-2 task-connection mb-5" style="flex:0 0 50%;">
        <div class="d-flex line-grouping line-left-bottom-corner py-2">
          @if (this.scope_flows.length == 0) {
            <div class="pr-3 align-self-center">
              <a class="connect-status" href="{{authUrl}}?s={{encodeState('f')}}">
                <i class="ms-Icon ms-Icon--PowerAutomateLogo" aria-hidden="true"></i>
              </a>
            </div>
          }
          @if (this.scope_flows.length > 0 && this.scope_flows.length > this.scope_flows_errors.length) {
            <div class="pr-3 align-self-center">
              <div class="connect-status connected">
                <fa-icon icon="check"></fa-icon>
              </div>
            </div>
          }
          <div class="text-light">
            <div class="font-weight-bolder">Access to Power Automate</div>
            @if (this.scope_flows_errors.length == 0 && this.scope_flows.length > 0) {
              <div>{{ this.scope_flows.length }} account(s) connected</div>
            }
            @if (this.scope_flows_errors.length > 0) {
              <div>
                <i class="ms-Icon ms-Icon--Unlock" aria-hidden="true" title="Re-authenticate"></i>
                {{ (this.scope_flows.length - this.scope_flows_errors.length) }} / {{ this.scope_flows.length }} account(s) connected
              </div>
            }
            <!-- <div>Scan Power Automate Platform</div> -->
            <div>
              <ul class="lines">
                @for (account of this.scope_flows; track account) {
                  <li>
                    <div>
                      @if (!account.error) {
                        <fa-icon icon="check"></fa-icon>
                      }
                      @if (account.error) {
                        <i class="ms-Icon ms-Icon--Unlock"  aria-hidden="true" title="Re-authenticate"></i>
                      }
                      <span>{{account.name}}</span>&nbsp;
                      <span>({{account.unique_name}})</span>
                    </div>
                    @if (account.error) {
                      <div>
                        There is a <a style="text-decoration: dashed underline;" [title]="account.error">problem refreshing token</a> to scan the Power Platform on your behalf.
                        Please
                        <a href="{{authUrl}}?domain_hint={{account.RowKey}}&login_hint={{account.unique_name}}&s={{encodeState('f')}}">
                          <i class="ms-Icon ms-Icon--Unlock" aria-hidden="true" title="Re-authenticate"></i>
                          re-authenticate this account
                        </a> to fix this.<br>
                        <!-- <code>{{account.error}}</code> -->
                      </div>
                    }
                    <!-- {{account|json}} -->
                  </li>
                }
                <li>
                  <a href="{{authUrl}}?domain_hint={{(user$|async)?.tid}}&login_hint={{(user$|async)?.unique_name}}&s={{encodeState('f')}}">
                    <i class="ms-Icon ms-Icon--Unlock" aria-hidden="true" title="Add Account"></i>
                    Add this permission
                  </a><br>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="d-flex line-grouping line-left-t py-2">
          @if (this.scope_apps.length == 0) {
            <div class="pr-3 align-self-center">
              <a class="connect-status" href="{{authUrl}}?s={{encodeState('p')}}">
                <i class="ms-Icon ms-Icon--PowerAppsLogo" aria-hidden="true"></i>
              </a>
            </div>
          }
          @if (this.scope_apps.length > 0 && this.scope_apps.length > this.scope_apps_errors.length) {
            <div class="pr-3 align-self-center">
              <div class="connect-status connected">
                <fa-icon icon="check"></fa-icon>
              </div>
            </div>
          }
          <div class="text-light">
            <div class="font-weight-bolder">Access to Power Apps</div>
            @if (this.scope_apps_errors.length == 0) {
              <div>{{ this.scope_apps.length }} account(s) connected</div>
            }
            @if (this.scope_apps_errors.length > 0) {
              <div>
                <i class="ms-Icon ms-Icon--Unlock" aria-hidden="true" title="Re-authenticate"></i>
                {{ (this.scope_apps.length - this.scope_apps_errors.length) }} / {{ this.scope_apps.length }} account(s) connected
              </div>
            }
            <!-- <div>Scan Power Apps Platform</div> -->
            <div>
              <ul class="lines">
                @for (account of this.scope_apps; track account) {
                  <li>
                    @if (!account.pa_error) {
                      <fa-icon icon="check"></fa-icon>
                    }
                    @if (account.error) {
                      <i class="ms-Icon ms-Icon--Unlock"  aria-hidden="true" title="Re-authenticate"></i>
                    }
                    <span>{{account.name}}</span>&nbsp;
                    <span>({{account.unique_name}})</span>
                    @if (account.pa_error) {
                      <div>
                        There is a <a style="text-decoration: dashed underline;" [title]="account.pa_error">problem refreshing token</a> to scan the Power Platform on your behalf.
                        Please
                        <a href="{{authUrl}}?domain_hint={{account.RowKey}}&login_hint={{account.unique_name}}&s={{encodeState('p')}}">
                          <i class="ms-Icon ms-Icon--Unlock" aria-hidden="true" title="Re-authenticate"></i>
                          re-authenticate this account
                        </a> to fix this.<br>
                        <!-- <code>{{account.error}}</code> -->
                      </div>
                    }
                    <!-- {{account|json}} -->
                  </li>
                }
                <li>
                  <a href="{{authUrl}}?domain_hint={{(user$|async)?.tid}}&login_hint={{(user$|async)?.unique_name}}&s={{encodeState('p')}}">
                    <i class="ms-Icon ms-Icon--Unlock" aria-hidden="true" title="Add Account"></i>
                    Add this permission
                  </a><br>
                </li>
              </ul>
            </div>

          </div>
        </div>

        <div class="d-flex line-grouping line-left-t py-2">
          @if (this.scope_graph.length == 0) {
            <div class="pr-3 align-self-center">
              <a class="connect-status" href="{{authUrl}}?s={{encodeState('g')}}">
                <i class="ms-Icon ms-Icon--PowerAppsLogo" aria-hidden="true"></i>
              </a>
            </div>
          }
          @if (this.scope_graph.length > 0 && this.scope_graph.length > this.scope_graph_errors.length) {
            <div class="pr-3 align-self-center">
              <div class="connect-status connected">
                <fa-icon icon="check"></fa-icon>
              </div>
            </div>
          }
          <div class="text-light">
            <div class="font-weight-bolder">Access to Microsoft Graph</div>
            @if (this.scope_graph_errors.length == 0) {
              <div>{{ this.scope_graph.length }} account(s) connected</div>
            }
            @if (this.scope_graph_errors.length > 0) {
              <div>
                <i class="ms-Icon ms-Icon--Unlock" aria-hidden="true" title="Re-authenticate"></i>
                {{ (this.scope_graph.length - this.scope_graph_errors.length) }} / {{ this.scope_graph.length }} account(s) connected
              </div>
            }
            <!-- <div>Scan Power Apps Platform</div> -->
            <div>
              <ul class="lines">
                @for (account of this.scope_graph; track account) {
                  <li>
                    @if (!account.g_error) {
                      <fa-icon icon="check"></fa-icon>
                    }
                    @if (account.g_error) {
                      <i class="ms-Icon ms-Icon--Unlock"  aria-hidden="true" title="Re-authenticate"></i>
                    }
                    <span>{{account.name}}</span>&nbsp;
                    <span>({{account.unique_name}})</span>
                    @if (account.g_error) {
                      <div>
                        There is a <a style="text-decoration: dashed underline;" [title]="account.g_error">problem refreshing token</a> to scan the Power Platform on your behalf.
                        Please
                        <a href="{{authUrl}}?domain_hint={{account.RowKey}}&login_hint={{account.unique_name}}&s={{encodeState('g')}}">
                          <i class="ms-Icon ms-Icon--Unlock" aria-hidden="true" title="Re-authenticate"></i>
                          re-authenticate this account
                        </a> to fix this.<br>
                        <!-- <code>{{account.g_error}}</code> -->
                      </div>
                    }
                    <!-- {{account|json}} -->
                  </li>
                }
                <li>
                  <a href="{{authUrl}}?domain_hint={{(user$|async)?.tid}}&login_hint={{(user$|async)?.unique_name}}&s={{encodeState('g')}}">
                    <i class="ms-Icon ms-Icon--Unlock" aria-hidden="true" title="Add Account"></i>
                    Add this permission
                  </a><br>
                </li>
              </ul>
            </div>

          </div>
        </div>

        @if (false) {
          <div class="d-flex line-grouping line-left-t py-2">
            @if (this.scope_pp.length == 0) {
              <div class="pr-3 align-self-center">
                <a class="connect-status" href="{{authUrl}}?s={{encodeState('pp')}}">
                  <i class="ms-Icon ms-Icon--PowerAppsLogo" aria-hidden="true"></i>
                </a>
              </div>
            }
            @if (this.scope_pp.length > 0 && this.scope_pp.length > this.scope_pp_errors.length) {
              <div class="pr-3 align-self-center">
                <div class="connect-status connected">
                  <fa-icon icon="check"></fa-icon>
                </div>
              </div>
            }
            <div class="text-light">
              <div class="font-weight-bolder">Access to Power Platform API</div>
              @if (this.scope_pp_errors.length == 0) {
                <div>{{ this.scope_pp.length }} account(s) connected</div>
              }
              @if (this.scope_pp_errors.length > 0) {
                <div>
                  <i class="ms-Icon ms-Icon--Unlock" aria-hidden="true" title="Re-authenticate"></i>
                  {{ (this.scope_pp.length - this.scope_pp_errors.length) }} / {{ this.scope_pp.length }} account(s) connected
                </div>
              }
              <!-- <div>Scan Power Apps Platform</div> -->
              <div>
                <ul class="lines">
                  @for (account of this.scope_pp; track account) {
                    <li>
                      @if (!account.pp_error) {
                        <fa-icon icon="check"></fa-icon>
                      }
                      @if (account.pp_error) {
                        <i class="ms-Icon ms-Icon--Unlock"  aria-hidden="true" title="Re-authenticate"></i>
                      }
                      <span>{{account.name}}</span>&nbsp;
                      <span>({{account.unique_name}})</span>
                      @if (account.pp_error) {
                        <div>
                          There is a <a style="text-decoration: dashed underline;" [title]="account.pp_error">problem refreshing token</a> to scan the Power Platform on your behalf.
                          Please
                          <a href="{{authUrl}}?domain_hint={{account.RowKey}}&login_hint={{account.unique_name}}&s={{encodeState('pp')}}">
                            <i class="ms-Icon ms-Icon--Unlock" aria-hidden="true" title="Re-authenticate"></i>
                            re-authenticate this account
                          </a> to fix this.<br>
                          <!-- <code>{{account.error}}</code> -->
                        </div>
                      }
                      <!-- {{account|json}} -->
                    </li>
                  }
                  <li>
                    <a href="{{authUrl}}?domain_hint={{(user$|async)?.tid}}&login_hint={{(user$|async)?.unique_name}}&s={{encodeState('pp')}}">
                      <i class="ms-Icon ms-Icon--Unlock" aria-hidden="true" title="Add Account"></i>
                      Add this permission
                    </a><br>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        }


        @if (false) {
          <div class="-d-flex line-grouping line-left-t py-2 d-none">
            <div class="pr-3 align-self-center">
              @if (!this.cds_default) {
                <div class="connect-status">
                  <i class="ms-Icon ms-Icon--CommonDataServiceCDS" aria-hidden="true"></i>
                </div>
              }
              @if (this.cds_default && this.cds.length == 0) {
                <a class="connect-status active" href="{{authUrl}}?cds={{this.cds_default}}">
                  <i class="ms-Icon ms-Icon--CommonDataServiceCDS" aria-hidden="true"></i>
                </a>
              }
              @if (this.cds.length > 0 && this.cds.length > this.cds_errors.length) {
                <div class="connect-status connected">
                  <fa-icon icon="check"></fa-icon>
                </div>
              }
            </div>
            <div class="text-light">
              <div class="font-weight-bolder">Access to Dataverse</div>
              @if (this.cds_errors.length == 0) {
                <div>{{ this.cds.length }} account(s) connected.</div>
              }
              @if (this.cds_errors.length > 0) {
                <div>
                  <i class="ms-Icon ms-Icon--Unlock" aria-hidden="true" title="Re-authenticate"></i>
                  {{ (this.cds.length - this.cds_errors.length) }} / {{ this.cds.length }} account(s) connected
                </div>
              }
              <!-- <div>Read solutions</div> -->
              <div>
                <ul class="lines">
                  @for (account of this.cds; track account) {
                    <li>
                      @if (!account.error) {
                        <fa-icon icon="check"></fa-icon>
                      }
                      @if (account.error) {
                        <i class="ms-Icon ms-Icon--Unlock"  aria-hidden="true" title="Re-authenticate"></i>
                      }
                      <span>{{account.name}}</span>&nbsp;
                      <span>({{account.unique_name}})</span>
                      @if (account.error) {
                        <div>
                          There is a <a style="text-decoration: dashed underline;" [title]="account.error">problem refreshing token</a> to scan the Power Platform on your behalf.
                          Please
                          <a href="{{authUrl}}?domain_hint={{account.RowKey}}&login_hint={{account.unique_name}}&s={{encodeState('f',this.cds_default)}}">
                            <i class="ms-Icon ms-Icon--Unlock" aria-hidden="true" title="Re-authenticate"></i>
                            re-authenticate this account
                          </a> to fix this.<br>
                          <!-- <code>{{account.error}}</code> -->
                        </div>
                      }
                      <!-- {{account|json}} -->
                    </li>
                  }
                </ul>
              </div>
            </div>
          </div>
        }
        @if (false) {
          <div class="d-flex line-grouping line-left-top-corner py-2" >
            @if (this.scope_events.length == 0) {
              <div class="pr-3 align-self-center">
                <a class="connect-status" href="{{authUrl}}?s={{encodeState('o')}}">
                  <i class="ms-Icon ms-Icon--PageListFilter" aria-hidden="true"></i>
                </a>
              </div>
            }
            @if (this.scope_events.length > 0 && this.scope_events.length > this.scope_events_errors.length) {
              <div class="pr-3 align-self-center">
                <div class="connect-status connected">
                  <fa-icon icon="check"></fa-icon>
                </div>
              </div>
            }
            <div class="text-light">
              <div class="font-weight-bolder">Access to M365 Logs</div>
              @if (this.scope_events_errors.length == 0) {
                <div>{{ this.scope_events.length }} account(s) connected</div>
              }
              @if (this.scope_events_errors.length > 0) {
                <div>
                  <i class="ms-Icon ms-Icon--Unlock" aria-hidden="true" title="Re-authenticate"></i>
                  {{ (this.scope_events.length - this.scope_events_errors.length) }} / {{ this.scope_events.length }} account(s) connected
                </div>
              }
              <!-- <div>Read M365 Audit Logs</div> -->
              <div>
                <ul class="lines">
                  @for (account of this.scope_events; track account) {
                    <li>
                      @if (!account.o_errors) {
                        <fa-icon icon="check"></fa-icon>
                      }
                      @if (account.o_errors) {
                        <i class="ms-Icon ms-Icon--Unlock"  aria-hidden="true" title="Re-authenticate"></i>
                      }
                      <span>{{account.name}}</span>&nbsp;
                      <span>({{account.unique_name}})</span>
                      @if (account.o_errors) {
                        <div>
                          There is a <a style="text-decoration: dashed underline;" [title]="account.o_errors">problem refreshing token</a> to scan the Power Platform on your behalf.
                          Please
                          <a href="{{authUrl}}?domain_hint={{account.RowKey}}&login_hint={{account.unique_name}}&s={{encodeState('o')}}">
                            <i class="ms-Icon ms-Icon--Unlock" aria-hidden="true" title="Re-authenticate"></i>
                            re-authenticate this account
                          </a> to fix this.<br>
                          <!-- <code>{{account.error}}</code> -->
                        </div>
                      }
                      <!-- {{account|json}} -->
                    </li>
                  }
                  <li>
                    <a href="{{authUrl}}?domain_hint={{(user$|async)?.tid}}&login_hint={{(user$|async)?.unique_name}}&s={{encodeState('o')}}">
                      <i class="ms-Icon ms-Icon--Unlock" aria-hidden="true" title="Add Account"></i>
                      Add this permission
                    </a><br>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        }
        <!-- <div class="d-flex line-grouping line-left-top-corner py-2">
        <div class="pr-3 align-self-center">
          <div class="connect-status">
            <i class="ms-Icon ms-Icon--PowerAppsLogo" aria-hidden="true" *ngIf="this.pp.length == 0"></i>
          </div>
          <a class="connect-status active" href="/api/auth?pp=1">
            <i class="ms-Icon ms-Icon--PowerAppsLogo" aria-hidden="true"></i>
          </a>
          <div class="connect-status connected" *ngIf="this.pp.length > 0">
            <fa-icon icon="check"></fa-icon>
          </div>

        </div>
        <div class="text-light">
          <div class="font-weight-bolder">Access to Granular Power Platform API</div>
          <div>Read obscure parts of Power Platform</div>
        </div>
      </div> -->

      <!-- {{ accounts$|async|json }} -->

    </div>


  </kendo-card-body>
  <!-- <hr kendoCardSeparator> -->
  <kendo-card-actions>
  </kendo-card-actions>
</kendo-card>
</kendo-gridlayout-item>
<kendo-gridlayout-item [col]="2">
  <kendo-card style=" width: 100%;">
    <!-- <kendo-card-header>
    Scan
  </kendo-card-header> -->
  <kendo-card-body class="d-flex">

    <div class="task-connection-line align-self-center">

      <div class="d-flex task-connection-category flex-direction-column">
        <div class="pr-3 align-self-center">
          <div class="settings-category-badge">
            <!-- <h4>2/4</h4> -->
            <h4><fa-icon icon="magnifying-glass"></fa-icon></h4>
            <svg xmlns="http://www.w3.org/2000/svg" width="75" height="74.999" viewBox="0 0 75 74.999">
              <g id="Group_294" data-name="Group 294" transform="translate(-249.439 -418.498)">
                <circle id="Ellipse_15" data-name="Ellipse 15" cx="31.042" cy="31.042" r="31.042" transform="translate(255.897 424.955)" fill="#37c6d0"/>
                <g id="Group_292" data-name="Group 292" transform="translate(249.439 418.498)">
                  <path id="Path_376" data-name="Path 376" d="M286.939,493.5h-.074v-3.763h.074a34.038,34.038,0,0,0,5.342-.421l.591,3.717A37.87,37.87,0,0,1,286.939,493.5Zm-3.091-.126a37.718,37.718,0,0,1-5.952-.972l.9-3.653a33.862,33.862,0,0,0,5.355.875Zm11.984-.936-.889-3.655a33.531,33.531,0,0,0,5.153-1.708l1.469,3.465A37.361,37.361,0,0,1,295.831,492.435ZM275,491.554a37.412,37.412,0,0,1-5.545-2.377l1.757-3.328a33.5,33.5,0,0,0,4.986,2.137Zm29.3-2.306-1.743-3.334a33.906,33.906,0,0,0,4.592-2.9l2.255,3.011A37.66,37.66,0,0,1,304.294,489.248Zm-37.453-1.586a37.63,37.63,0,0,1-4.812-3.634l2.5-2.811a33.928,33.928,0,0,0,4.331,3.271Zm44.9-3.536-2.49-2.821a33.961,33.961,0,0,0,3.77-3.906l2.908,2.388A37.792,37.792,0,0,1,311.74,484.125Zm-51.884-2.191a37.761,37.761,0,0,1-3.811-4.675l3.1-2.136a33.928,33.928,0,0,0,3.429,4.208Zm57.891-4.554-3.089-2.148a33.837,33.837,0,0,0,2.728-4.688l3.394,1.624A37.566,37.566,0,0,1,317.748,477.381Zm-63.315-2.675a37.537,37.537,0,0,1-2.583-5.454l3.52-1.33a33.653,33.653,0,0,0,2.324,4.9Zm67.541-5.308-3.514-1.345a33.678,33.678,0,0,0,1.522-5.207l3.685.761A37.4,37.4,0,0,1,321.973,469.4ZM250.9,466.387a37.431,37.431,0,0,1-1.194-5.913l3.737-.445a33.64,33.64,0,0,0,1.073,5.317Zm73.258-5.759-3.735-.461a34.218,34.218,0,0,0,.254-4.171c0-.419-.007-.837-.023-1.253l3.76-.139q.026.693.025,1.392A38.044,38.044,0,0,1,324.156,460.628Zm-74.689-3.164q-.027-.731-.028-1.467a38,38,0,0,1,.274-4.554l3.735.452a34.189,34.189,0,0,0-.247,4.1c0,.443.009.885.025,1.325Zm70.979-5.43a33.682,33.682,0,0,0-1.063-5.319L323,445.682a37.485,37.485,0,0,1,1.182,5.916Zm-66.563-2.819-3.687-.752a37.334,37.334,0,0,1,1.681-5.795l3.517,1.338A33.565,33.565,0,0,0,253.883,449.215Zm64.65-5.078a33.631,33.631,0,0,0-2.312-4.909l3.263-1.874a37.433,37.433,0,0,1,2.572,5.461Zm-62.073-2.625-3.4-1.618a37.585,37.585,0,0,1,3.022-5.217l3.093,2.142A33.771,33.771,0,0,0,256.46,441.513Zm58.314-4.584a34.061,34.061,0,0,0-3.421-4.215l2.722-2.6a37.726,37.726,0,0,1,3.8,4.683Zm-53.961-2.279-2.913-2.383a37.87,37.87,0,0,1,4.18-4.347l2.5,2.817A33.964,33.964,0,0,0,260.813,434.649Zm48.588-3.825a34.052,34.052,0,0,0-4.325-3.279l2.026-3.17a37.664,37.664,0,0,1,4.805,3.643Zm-42.722-1.806-2.262-3.007a37.531,37.531,0,0,1,5.1-3.228l1.751,3.33A33.8,33.8,0,0,0,266.68,429.018Zm36.052-2.841a33.636,33.636,0,0,0-4.982-2.148l1.206-3.565a37.551,37.551,0,0,1,5.54,2.389Zm-29.012-1.229-1.476-3.461a37.248,37.248,0,0,1,5.728-1.91l.9,3.654A33.468,33.468,0,0,0,273.719,424.948Zm21.427-1.683a33.641,33.641,0,0,0-5.353-.886l.315-3.75a37.629,37.629,0,0,1,5.951.986Zm-13.618-.573-.6-3.715a37.867,37.867,0,0,1,6.01-.479h.161l-.025,3.762h-.136A34.1,34.1,0,0,0,281.528,422.692Z" transform="translate(-249.439 -418.498)" fill="#37c6d0"/>
                </g>
              </g>
            </svg>
          </div>
        </div>
        <div class="pr-3 text-light align-self-center">
          Scan
          <!-- <a class="connect-link" href disabled>Add and view accounts</a> -->
          <!-- popup -->

          <!-- {{ this.accounts | json }} -->
        </div>
      </div>
    </div>

    @if ((scans$|async); as scans) {
      <div>
        @for (scan of scans; track scan; let i = $index) {
          <div>
            @if (this.findAccount(scan.account); as account) {
              Scanning with [{{ account.unique_name }}] {{ scan?.ended ?  "completed" : "in progress" }}.
              <ul class="lines">
                <li><i class="ms-Icon ms-Icon--Clock align-text-bottom"></i>&nbsp;{{ ((scansTimespan$ | async)||[]).at(i) }}</li>
                <!-- <li><fa-icon [icon]="['far','clock']"></fa-icon>&nbsp;{{ scans?.start }}</li>
                <li><fa-icon [icon]="['far','clock']"></fa-icon>&nbsp;{{ scans?.end }}</li> -->
                <li><i class="ms-Icon ms-Icon--MapLayers align-text-bottom"></i>&nbsp;{{ scan?.envs }} environments</li>
                <li><i class="ms-Icon ms-Icon--PowerAppsLogo align-text-bottom"></i>&nbsp;{{ scan?.apps }} apps</li>
                <li><i class="ms-Icon ms-Icon--PowerAutomateLogo align-text-bottom"></i>&nbsp;{{ scan?.flows }} flows</li>
              </ul>
            }
          </div>
        }
        @if (scans.length == 0) {
          <div>
            To start scanning, add permissions for Power Automate and Power Apps.
          </div>
        }
      </div>
    } @else {
      ...
    }
  </kendo-card-body>
  <!-- <hr kendoCardSeparator> -->
  <kendo-card-actions>
  </kendo-card-actions>
</kendo-card>
</kendo-gridlayout-item>
<kendo-gridlayout-item [col]="2">
  <kendo-card style="width: 100%;">
    <!-- <kendo-card-header>
    Monitor
  </kendo-card-header> -->
  <kendo-card-body class="d-flex">
    <div class="task-connection-line align-self-center">

      <div class="d-flex task-connection-category flex-direction-column">
        <div class="pr-3 align-self-center">
          <div class="settings-category-badge">
            <!-- <h4>2/4</h4> -->
            <h4><fa-icon icon="magnifying-glass-chart"></fa-icon></h4>
            <svg xmlns="http://www.w3.org/2000/svg" width="75" height="74.999" viewBox="0 0 75 74.999">
              <g id="Group_294" data-name="Group 294" transform="translate(-249.439 -418.498)">
                <circle id="Ellipse_15" data-name="Ellipse 15" cx="31.042" cy="31.042" r="31.042" transform="translate(255.897 424.955)" fill="#37c6d0"/>
                <g id="Group_292" data-name="Group 292" transform="translate(249.439 418.498)">
                  <path id="Path_376" data-name="Path 376" d="M286.939,493.5h-.074v-3.763h.074a34.038,34.038,0,0,0,5.342-.421l.591,3.717A37.87,37.87,0,0,1,286.939,493.5Zm-3.091-.126a37.718,37.718,0,0,1-5.952-.972l.9-3.653a33.862,33.862,0,0,0,5.355.875Zm11.984-.936-.889-3.655a33.531,33.531,0,0,0,5.153-1.708l1.469,3.465A37.361,37.361,0,0,1,295.831,492.435ZM275,491.554a37.412,37.412,0,0,1-5.545-2.377l1.757-3.328a33.5,33.5,0,0,0,4.986,2.137Zm29.3-2.306-1.743-3.334a33.906,33.906,0,0,0,4.592-2.9l2.255,3.011A37.66,37.66,0,0,1,304.294,489.248Zm-37.453-1.586a37.63,37.63,0,0,1-4.812-3.634l2.5-2.811a33.928,33.928,0,0,0,4.331,3.271Zm44.9-3.536-2.49-2.821a33.961,33.961,0,0,0,3.77-3.906l2.908,2.388A37.792,37.792,0,0,1,311.74,484.125Zm-51.884-2.191a37.761,37.761,0,0,1-3.811-4.675l3.1-2.136a33.928,33.928,0,0,0,3.429,4.208Zm57.891-4.554-3.089-2.148a33.837,33.837,0,0,0,2.728-4.688l3.394,1.624A37.566,37.566,0,0,1,317.748,477.381Zm-63.315-2.675a37.537,37.537,0,0,1-2.583-5.454l3.52-1.33a33.653,33.653,0,0,0,2.324,4.9Zm67.541-5.308-3.514-1.345a33.678,33.678,0,0,0,1.522-5.207l3.685.761A37.4,37.4,0,0,1,321.973,469.4ZM250.9,466.387a37.431,37.431,0,0,1-1.194-5.913l3.737-.445a33.64,33.64,0,0,0,1.073,5.317Zm73.258-5.759-3.735-.461a34.218,34.218,0,0,0,.254-4.171c0-.419-.007-.837-.023-1.253l3.76-.139q.026.693.025,1.392A38.044,38.044,0,0,1,324.156,460.628Zm-74.689-3.164q-.027-.731-.028-1.467a38,38,0,0,1,.274-4.554l3.735.452a34.189,34.189,0,0,0-.247,4.1c0,.443.009.885.025,1.325Zm70.979-5.43a33.682,33.682,0,0,0-1.063-5.319L323,445.682a37.485,37.485,0,0,1,1.182,5.916Zm-66.563-2.819-3.687-.752a37.334,37.334,0,0,1,1.681-5.795l3.517,1.338A33.565,33.565,0,0,0,253.883,449.215Zm64.65-5.078a33.631,33.631,0,0,0-2.312-4.909l3.263-1.874a37.433,37.433,0,0,1,2.572,5.461Zm-62.073-2.625-3.4-1.618a37.585,37.585,0,0,1,3.022-5.217l3.093,2.142A33.771,33.771,0,0,0,256.46,441.513Zm58.314-4.584a34.061,34.061,0,0,0-3.421-4.215l2.722-2.6a37.726,37.726,0,0,1,3.8,4.683Zm-53.961-2.279-2.913-2.383a37.87,37.87,0,0,1,4.18-4.347l2.5,2.817A33.964,33.964,0,0,0,260.813,434.649Zm48.588-3.825a34.052,34.052,0,0,0-4.325-3.279l2.026-3.17a37.664,37.664,0,0,1,4.805,3.643Zm-42.722-1.806-2.262-3.007a37.531,37.531,0,0,1,5.1-3.228l1.751,3.33A33.8,33.8,0,0,0,266.68,429.018Zm36.052-2.841a33.636,33.636,0,0,0-4.982-2.148l1.206-3.565a37.551,37.551,0,0,1,5.54,2.389Zm-29.012-1.229-1.476-3.461a37.248,37.248,0,0,1,5.728-1.91l.9,3.654A33.468,33.468,0,0,0,273.719,424.948Zm21.427-1.683a33.641,33.641,0,0,0-5.353-.886l.315-3.75a37.629,37.629,0,0,1,5.951.986Zm-13.618-.573-.6-3.715a37.867,37.867,0,0,1,6.01-.479h.161l-.025,3.762h-.136A34.1,34.1,0,0,0,281.528,422.692Z" transform="translate(-249.439 -418.498)" fill="#37c6d0"/>
                </g>
              </g>
            </svg>
          </div>
        </div>
        <div class="pr-3 text-light align-self-center">
          Monitor
          <!-- <a class="connect-link" href disabled>Add and view accounts</a> -->
          <!-- popup -->

          <!-- {{ this.accounts | json }} -->
        </div>
      </div>
    </div>

    <div>
      Use "Flows" or "Admin" views to find and select flows to be monitored.
    </div>
  </kendo-card-body>
  <!-- <hr kendoCardSeparator> -->
  <kendo-card-actions>
  </kendo-card-actions>
</kendo-card>

</kendo-gridlayout-item>

</kendo-gridlayout>

